<template>
    <div>
        <v-row class="px-2 pt-2">
            <v-col md="4" class="py-0">
                <v-select
                    v-model="option"
                    label="Date Range"
                    :items="options"
                    dense
                    @change="getChart"
                ></v-select>
            </v-col>

            <v-col md="12" class="pa-2">
                <chart
                    v-if="chartData"
                    ref="chart"
                    :chartData="chartData"
                ></chart>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import Chart from '@/components/reports/charts/TpProcessing.vue';

export default {
    components: {
        'chart': Chart,
    },
    data() {
        return {
            chartData: null,
            option: 0,
            options: [{ text: 'Last 30 Days', value: 0 },
                      { text: 'Last 6 Months', value: 1}]
        }
    },
    beforeMount() {
        this.getChart();
    },
    methods: {
        getChart() {
            let url = this.option == 0
            ? 'tp-daily-processing'
            : 'tp-monthly-processing'

            axios({
            method: 'get',
            url: url,
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.chartData = this.option == 0 ? response.data.reverse() : response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        }
    }
}
</script>